/**
 * Strategy contact form (Gravity Forms): group the first four `.gfield` rows
 * into one wrapper and the remaining fields into another, for two-column layout.
 *
 * The `strategy-from` / `strategy-form` class is expected on the `<form>` (GF “Form CSS Class”).
 * Field rows are the direct children `.gfield` of `.gform_fields` inside that form.
 */

const PRIMARY_CLASS = 'strategy-form__fields strategy-form__fields--primary';
const SECONDARY_CLASS = 'strategy-form__fields strategy-form__fields--secondary';

function wrapStrategyFormColumns() {
  document.querySelectorAll('form.strategy-form').forEach((form) => {
    const fieldsRoot = form.querySelector('.gform_fields');
    if (!fieldsRoot) {
      return;
    }

    if (fieldsRoot.querySelector(':scope > .strategy-form__fields')) {
      return;
    }

    const fields = [...fieldsRoot.querySelectorAll(':scope > .gfield')];
    if (fields.length <= 4) {
      return;
    }

    const primary = document.createElement('div');
    primary.className = PRIMARY_CLASS;

    const secondary = document.createElement('div');
    secondary.className = SECONDARY_CLASS;

    fields.slice(0, 4).forEach((el) => primary.appendChild(el));
    fields.slice(4).forEach((el) => secondary.appendChild(el));

    fieldsRoot.appendChild(primary);
    fieldsRoot.appendChild(secondary);
  });
}

function initStrategyFormLayout() {
  wrapStrategyFormColumns();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStrategyFormLayout);
} else {
  initStrategyFormLayout();
}

if (window.jQuery) {
  jQuery(document).on('gform_post_render', initStrategyFormLayout);
}
